<template>
  <v-row class="pa-0">
    <v-col cols="12" md="4">
      <v-card :loading="loading">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle class="text-overline">Usuarios</v-list-item-subtitle>
            <v-list-item-subtitle>Total</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold text-h6 mb-0">{{ stats.total }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-avatar :size="avatarSize" color="grey lighten-2">
            <v-icon :size="iconSize">mdi-account-multiple-outline</v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </v-col>

    <v-col cols="12" md="4">
      <v-card :loading="loading">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle class="text-overline">Usuarios</v-list-item-subtitle>
            <v-list-item-subtitle>Habilitados</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold text-h6 mb-0">{{ stats.enabled }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-avatar :size="avatarSize" color="grey lighten-2">
            <v-icon :size="iconSize">mdi-account-check-outline</v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </v-col>

    <v-col cols="12" md="4">
      <v-card :loading="loading">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle class="text-overline">Usuarios</v-list-item-subtitle>
            <v-list-item-subtitle>Deshabilitados</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold text-h6 mb-0">{{ stats.disabled }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-avatar :size="avatarSize" color="grey lighten-2">
            <v-icon :size="iconSize">mdi-account-off-outline</v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import UserService from '../../../services/UserService'

export default {
  data: () => ({
    loading: false,
    stats: {
      total: 0,
      enabled: 0,
      disabled: 0
    },
    user: []
  }),

  computed: {
    avatarSize () {
      return this.$vuetify.breakpoint.smAndDown ? 40 : 60
    },
    iconSize () {
      return this.$vuetify.breakpoint.smAndDown ? 24 : 36
    }
  },

  methods: {
    async loadData () {
      this.loading = true
      await UserService.get().then(({ data }) => {
        this.stats.total = data._meta.totalCount
        this.user = data.data
        this.loading = false
      })
      this.user.forEach(user => {
        if (user.status === 10) {
          this.stats.enabled++
        } else {
          this.stats.disabled++
        }
      })
    }
  },

  async created () {
    await this.loadData()
  }
}
</script>

<style scoped>
/* Ajustes adicionales para pantallas pequeñas */
@media (max-width: 600px) {
  .v-list-item__subtitle {
    font-size: 12px;
  }
  .v-list-item__title {
    font-size: 16px;
  }
}
</style>
